import { useState } from "react"

export const ReviewsRatings = () => {
    const [reviewList, setRewivewList] = useState([])
    const [listLoader, setListLoader] = useState(true)
    const [inftScroll, setInftScroll] = useState(true)
    const [lid, setLid] = useState(0)
    const [limit] = useState(10)
    const [view, setView] = useState({show: false, id: '', loader: false})
    const [details, setDetails] = useState({info: '', imgs: []})
    const [search, setSearch] = useState('')
    return {
        reviewList: {data: reviewList, set: setRewivewList},
        listLoader: {data: listLoader, set: setListLoader},
        inftScroll: {data: inftScroll, set: setInftScroll},
        lid: {data: lid, set: setLid},
        limit: {data: limit},
        view: {data: view, set: setView},
        details: {data: details, set: setDetails},
        search: {data: search, set: setSearch},
    }
}
